import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {Image} from '@app/components/Image';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '4e23a030ccfb5797b76bce81c5f53eed.png',
	fr: '16b08f190e74c6dd19c13b05755676d7.png',
};

export const OfflineTap: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'offlinelandingpage_title_yourdownloadsinonetap_standalone-web',
							{ns: 'offline'},
						)}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('offlinelandingpage_text_yourdownloadsinonetap_standalone-web', {
							ns: 'offline',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					objectFit="cover"
					aspectRatio="2880/840"
					quality="90"
					h={{base: '250px', md: '450px', lg: '600px'}}
					alt={t('metatag_text_accessdownloadsinoneplace_standalone-web', {
						ns: 'common',
					})}
					src={src}
				/>
			}
		/>
	);
};
